import moment from 'moment'
import {calculateDate} from '../../../utils'

export interface ObjectInsuredModel {
  id: number | null
  type: string | null
  timeDuration: string | null
  customerName: string | null
  addressName: string | null
  startDate: string | null
  expireDate: string | null
  gender: string | null
  relationship: string | null
  salary: string | null
  creditContractNumber: string | null
  partner: string | null
  employeeCode: string | null
  position: string | null
  from: string | null
  to: string | null
  loanType: string | null
  loanAmount: string | null
  loanTime: string | null
  EMIField: string | null
  certType: string | null
  certNumber: string | null
  hasLicense: string | null
  licensePlate: string | null
  chassisNumber: string | null
  engineNumber: string | null
  carCompany: string | null
  carBrand: string | null
  manufacturingYear: string | null
  seat: string | null
  driverNumber: string | null
  capacity: string | null
  purposeOfUseType: string | null
  price: string | null
  vehiclePackageBenefitDtos: any
  vehiclePackageExtensionDtos: any
  additionalBenefit: any
  vehicleGroupsCode: string | null
  payload: string | null
  packageCode: string | null
  businessProgramCode: string | null
  customerBirthDay: string | null
  identificationNumber: string | null
  mobile: string | null
  email: string | null
  sumFee: string | null
  sumTax: string | null
  objectInsuredType: number | null
  customerSource: number | null
  customerSegment: number | null
  coverage: string | null
  yearBuilt: string | null
  floorNumber: string | null
  ownerType: string | null
  houseType: string | null
  businessHouseType: string | null
  fireFighting: string | null
  sumInsured: string | null
}

interface InsuranceBuyerModel {
  customerName: string | null
  identificationNumber: string | null
  customerBirthDay: string | null
  gender: string | null
  addressName: string | null
  taxNumber: string | null
  phone: string | null
  mobile: string | null
  email: string | null
  employeeCode: string | null
  parentGroupCode: string | null
  loanAmount: string | null
  bank: string | null
  loanPurpose: string | null
  creditContractNumber: string | null
  loanTime: string | null
  customerType: number | null
  customerSegment: number | null
}

interface BussinessDetailModel {
  businessProgramId: number | null
  businessProgramType: number | null
  code: string | null
  from: number
  groupDomainCode: string | null
  id: number | null
  maxReductionFee: number
  packageCode: string | null
  reductionFee: number | null
  reductionRate: number | null
  status: number | null
  to: number
}

export interface ListObjectInsuredModel extends Array<ObjectInsuredModel> {}

export interface ListBussinessDetailModel extends Array<BussinessDetailModel> {}

export interface BanCasStateModel {
  tabName?: string
  sellingContractId?: string
  customerCode?: string
  customerVersion?: number
  groupDomainCode?: string
  businessProgramCode?: string
  packageInsurance?: any
  form: {
    activeForm: number
    fieldInput: any
    formStatus?: number
    currencyFee?: string
    currencyMoney?: string
    formData: {
      feeAdditional?: number
      listpackages?: any
      listBussinessDetails?: ListBussinessDetailModel
      formObjectInsured?: ListObjectInsuredModel
      formInsuranceBuyer?: InsuranceBuyerModel
    }
  }
}

export interface ListBanCasStateModel extends Array<BanCasStateModel> {}

export const bancasInitialState: ListBanCasStateModel = [
  {
    tabName: undefined,
    sellingContractId: undefined,
    customerCode: undefined,
    customerVersion: undefined,
    groupDomainCode: undefined,
    businessProgramCode: undefined,
    packageInsurance: undefined,
    form: {
      activeForm: 1,
      fieldInput: undefined,
      formStatus: undefined,
      currencyFee: undefined,
      currencyMoney: undefined,
      formData: {
        formObjectInsured: [
          {
            id: 0,
            type: null,
            timeDuration: null,
            customerName: null,
            addressName: null,
            startDate: moment().format('YYYY/MM/DD HH:mm'),
            expireDate: calculateDate(moment().format('YYYY/MM/DD HH:mm'), true),
            gender: null,
            relationship: null,
            salary: null,
            creditContractNumber: null,
            partner: null,
            employeeCode: null,
            position: null,
            from: null,
            to: null,
            loanType: null,
            loanAmount: null,
            loanTime: null,
            EMIField: null,
            certType: '1',
            certNumber: null,
            hasLicense: '1',
            licensePlate: null,
            chassisNumber: null,
            engineNumber: null,
            carCompany: null,
            carBrand: null,
            manufacturingYear: moment().year().toString(),
            seat: '5',
            driverNumber: '0',
            capacity: '0',
            purposeOfUseType: '2',
            price: '500,000,000',
            vehiclePackageBenefitDtos: [],
            vehiclePackageExtensionDtos: [],
            additionalBenefit: [],
            vehicleGroupsCode: null,
            payload: '0',
            packageCode: null,
            businessProgramCode: null,
            customerBirthDay: null,
            identificationNumber: null,
            mobile: null,
            email: null,
            sumFee: null,
            sumTax: null,
            objectInsuredType: 1,
            customerSource: 0,
            customerSegment: 0,
            coverage: '1',
            yearBuilt: null,
            floorNumber: null,
            ownerType: null,
            houseType: null,
            businessHouseType: null,
            fireFighting: null,
            sumInsured: null,
          },
        ],
        formInsuranceBuyer: {
          customerName: null,
          identificationNumber: null,
          customerBirthDay: null,
          gender: null,
          taxNumber: null,
          addressName: null,
          employeeCode: null,
          parentGroupCode: null,
          phone: null,
          mobile: null,
          email: null,
          loanAmount: null,
          bank: null,
          loanPurpose: null,
          creditContractNumber: null,
          loanTime: null,
          customerType: 1,
          customerSegment: 1,
        },
        listpackages: null,
        listBussinessDetails: undefined,
        feeAdditional: undefined
      },
    },
  },
]
